module.exports = __webpack_public_path__ + "media/images/ic-book-now-ec231cfaed6ef527e8b0311aced5d648.svg";